import React from 'react';
import styles from '../Operations.module.css';

interface SHRWComponent extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

/**
 * STOREHOURS - Store Hours
 * KPI information component
 */
const SHRW: SHRWComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>

      <div className={styles.sectionContent}>
        Measures how many hours the store is open Monday through Sunday.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>

      <div className={styles.sectionContent}>
        We aren&apos;t convenient if we&apos;re not open! Our competition serves customers significantly longer. Compared to the minimum recommended hours Mon-Sat, Tractor Supply is open 18% longer and Home Depot and Lowe&apos;s are open 45% longer. Stores who have increased their hours are seeing annual sales increases of $100k-$400k, far exceeding the cost in additional labor.
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>

      <div className={styles.sectionContent}>
       Open at least 75 hours a week<br/><br/>
        <em>Note: Rural stores without competition within five miles can qualify for pinnacle for Store Hours if the store is open &gt;66 hours M-Sunday.</em>
      </div>

      <div className={styles.sectionTitle}>
       Learn More
      </div>

      <div className={styles.sectionContent}>
        <strong>To change your store&apos;s regular hours:</strong>
        <ol>
          <li>In ACENET, on the <strong>Marketing</strong> tab, under <strong>Digital Marketing</strong>, click <strong>My Store</strong>.</li>
          <li>The My Store Dashboard Screen displays.</li>
          <li>In the left pane, under Store Hours, click <strong>Regular</strong>. The My Store Regular Hours Screen displays.</li>
          <li>Specify the opening and closing time for each day of the week.</li>
        </ol>
        <strong>Notes:</strong>
        <ul style={{ marginLeft: '20px' }}>
          <li>To indicate that the store is closed for an entire day, in the Open time column for that day of the week, click Closed.</li>
          <li>When you select Closed in the Open time column, you do not need to make a selection in the Close time column.</li>
        </ul>
        <ol start={5}>
          <li>When your store&apos;s normal opening and closing times are correct for every day of the week, click <strong>Submit</strong>.</li>
          <li>A message indicates that your regular store hours have been submitted. Click <strong>OK</strong>.</li>
          <li>To copy these hours to other stores in your chain, click Multi-Store. In the new screen that displays, select each store to copy this information.</li>
        </ol>
        <strong>Important:</strong> The regular hours for the selected stores will be replaced with the information from this screen.
      </div>
    </div>
  );
};

SHRW.title = 'Store Hours';
SHRW.actionTitle = 'Manage In My Store';
SHRW.actionHyperlink = 'dynamicURL:ACENET:current';
export default SHRW;

